try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {

}
var slick = require('slick-carousel');

require('jquery-scrollify');

var lity = require('lity');

import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import SignaturePad from "signature_pad";

document.addEventListener('DOMContentLoaded', function () {
    const calendarEl = document.getElementById('calendar');
    if (calendarEl) {
        let initialView = 'listMonth';
        let mql = window.matchMedia("(min-width: 768px)");
        if (mql.matches) {
            initialView = 'dayGridMonth';
        }
        const calendar = new Calendar(calendarEl, {
            initialView: 'dayGridMonth',
            contentHeight: 'auto',
            plugins: [dayGridPlugin,listPlugin],
            eventSources: [{url: '/?calendar'}],
            eventClick: function (info) {
                info.jsEvent.preventDefault();
                console.log(info)
                if (info.event.id) {
                    const myRequest = new Request(`/?calendar&id=${info.event.id}`);
                    fetch(myRequest)
                        .then((response) => response.text())
                        .then((text) => {
                            lity(text);
                        });
                }
            }
        });

        calendar.render();
    }

    const signatureForm = document.querySelector('[data-js-signature-form]');
    if (signatureForm) {
        const signatureCanvas = signatureForm.querySelector("canvas");

        const signaturePad = new SignaturePad(signatureCanvas);
        const signatureInput = signatureForm.querySelector("[data-input]");
        const clearButton = signatureForm.querySelector("[data-clear]");

        clearButton.addEventListener("click", function (event) {
            signaturePad.clear();
        });

        signatureForm.addEventListener("submit", (event) => {
            event.preventDefault();
            if (signaturePad.isEmpty()) {
                signatureInput.value = '';
            } else {
                signatureInput.value = signaturePad.toDataURL();
            }
            const $form = $(signatureForm);

            const $submit = $form.find('button[type=submit]');

            $form.attr("disabled", "disabled");

            //Serialise form data
            let formData = $form.serializeArray();
            formData.push({name: "checkForm", value: 1});

            $.post($form.attr('action'), formData, function (data) {
                $form.html('<div class="sent">' + data.success + '</div>');
            }).fail(function (xhr, textStatus) {
                $form.find('.is-invalid').removeClass('is-invalid');
                $form.find('.invalid-feedback').remove();
                console.log(xhr);
                if (xhr.status === 422) {
                    let unknown = [];
                    $.each(xhr.responseJSON.errors, function (key, value) {
                        let lookup = '';
                        let $input = $form.find('[name="' + key + '"],#' + key).first();
                        if (!$input.length) {
                            unknown.push(key + ':' + value);
                        }
                        if ($input.attr('type') == 'radio') {
                            $input.closest('fieldset').after('<span class="invalid-feedback">' + value + '</span>');
                        } else {
                            $input.after('<span class="invalid-feedback">' + value + '</span>');
                        }
                        $input.addClass('is-invalid');
                    });
                    if (unknown.length) {
                        $form.append('<pre class="invalid-feedback">' + 'The following errors were found:\n\n' + unknown.join('\n') + '</pre>');
                    }
                    $('html, body').animate({
                        scrollTop: $('.invalid-feedback:visible:first').offset().top-75
                    }, 500);
                } else {
                    alert(xhr.responseJSON.error);
                }
                $form.removeAttr('disabled');
            });
        });

        window.onresize = resizeCanvas;
        resizeCanvas();

        function resizeCanvas() {
            // When zoomed out to less than 100%, for some very strange reason,
            // some browsers report devicePixelRatio as less than 1
            // and only part of the canvas is cleared then.
            const ratio = Math.max(window.devicePixelRatio || 1, 1);

            // This part causes the canvas to be cleared
            signatureCanvas.width = signatureCanvas.offsetWidth * ratio;
            signatureCanvas.height = signatureCanvas.offsetHeight * ratio;
            signatureCanvas.getContext("2d").scale(ratio, ratio);

            // This library does not listen for canvas changes, so after the canvas is automatically
            // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
            // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
            // that the state of this library is consistent with visual state of the canvas, you
            // have to clear it manually.
            signaturePad.clear();
        }
    }
});


// Mobile nav toggle
(function ($) {
    const menuToggle = $('[data-js-nav-toggle]');
    (function () {
        if (!menuToggle.length) {
            return;
        }
        menuToggle.on('click.podium', function () {
            const siteNavContain = $('#' + $(this).attr('aria-controls'));
            $('body').toggleClass('nav-is-active');
            if ($('body').hasClass('nav-is-active')) {
                siteNavContain.attr('aria-expanded', true);
                $(this).addClass('is-active');
            } else {
                siteNavContain.attr('aria-expanded', false);
                $(this).removeClass('is-active');
            }
        });
    })();
})(jQuery);

(function ($) {
    const ns = 'data-js-slider';
    const $sliders = $('[' + ns + ']');
    (function () {
        if (!$sliders.length) {
            return;
        }
        $sliders.each(function () {
            $(this).slick({dots: true, arrows: false});
        });
    })();
})(jQuery);

(function ($) {
    const ns = 'data-js-price-list';
    const $teams = $('[' + ns + ']');
    (function () {
        if (!$teams.length) {
            return;
        }
        $teams.each(function () {
            const s = {
                container: $(this),
                trigger: $(this).find('>h3'),
                content: $(this).find('>div')
            };
            s.trigger.on('click', function (e) {
                e.preventDefault();
                const active = s.container.attr('aria-expanded') === 'true';
                if (!active) {
                    s.content.slideDown('fast');
                    s.container.attr('aria-expanded', true)
                } else {
                    s.content.slideUp('fast');
                    s.container.attr('aria-expanded', false)
                }
            });
        });
    })();
})(jQuery);

(function ($) {
    const ns = 'data-js-form';
    const $forms = $('[' + ns + ']');
    (function () {
        if (!$forms.length) {
            return;
        }
        $forms.each(function () {
            const $form = $(this);
            $form.on('submit', function (e) {
                e.preventDefault();
                const $submit = $form.find('button[type=submit]');
                $submit.width($submit.width()).text('...').prop('disabled', true);
                $.post($form.attr('action'), $form.serialize() + "&frm[checkForm]=1", function (data) {
                    $form.html('<div class="sent">' + data.success + '</div>');
                }).fail(function (jqXHR, textStatus) {
                    alert(jqXHR.responseJSON.error);
                });
            });
        });
    })();
})(jQuery);

// Scrollbar observer
(function ($) {
    const intro = document.querySelector('[data-js-intro]');
    if (!intro) {
        return;
    }
    const observer = new IntersectionObserver(function (entry, observer) {
        if (entry[0].isIntersecting) {
            $('body').addClass('is-top-of-page');
            if (location.hash !== "#price-list") {
                $.scrollify.enable();
                console.log('enabled');
                $.scrollify.previous();
            }
        } else {
            $('body').removeClass('is-top-of-page');
            $.scrollify.disable();
            console.log('disabled')
        }

    }, {rootMargin: '-100px'});
    observer.observe(intro);
})(jQuery);


// Next section
(function ($) {
    $('[data-js-scrollify-next]').click(function (e) {
        e.preventDefault();
        $.scrollify.next();
    });
})(jQuery);

(function ($) {
    const scenes = $('.scroll-snap');
    (function () {
        if (scenes.length < 2) {
            return;
        }
        if (location.hash === "#price-list") {
            console.log('disabled - price-list');
            return;
        }
        $.scrollify({
            section: ".scroll-snap",
            sectionName: false,
            easing: "easeOutExpo",
            interstitialSection: ".footer",
            scrollSpeed: 1000,
            offset: 0,
            scrollbars: true,
            standardScrollElements: ".footer",
            setHeights: false,
            overflowScroll: false,
            updateHash: false,
            touchScroll: false
        });
    })();
})(jQuery);

